import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RegisterPermissionType } from '@assetaccountant/api/models/register-permission-type';
import { AuthorizationService } from '@assetaccountant/core/services/authorization.service';
import { ModalService } from '@assetaccountant/core/services/modal.service';

import { environment } from '../../../../environments/environment';
import { ConnectIntegrationResponse } from '../models/common/connect-integration-response';
import { OidcStateParams } from '../models/oidc-state-params';
import { ConnectQuickBooksCommand } from '../models/quickbooks/connect-quickbooks-command';

export const quickBooksConfig = {
  responseType: 'code',
  scope: environment.quickBooks.scope,
  clientId: environment.quickBooks.clientId,
  redirectUri: environment.quickBooks.redirectUri,
  issuer: environment.quickBooks.issuer,
};

@Injectable({
  providedIn: 'root',
})
export class QuickBooksService {
  constructor(
    private http: HttpClient,
    private modalService: ModalService,
    private authorizationService: AuthorizationService,
  ) {}

  initiateOAuth(returnRoute: string) {
    const state = this.generateState(returnRoute);

    const url =
      quickBooksConfig.issuer +
      '?response_type=' +
      encodeURIComponent(quickBooksConfig.responseType) +
      '&client_id=' +
      encodeURIComponent(quickBooksConfig.clientId) +
      '&state=' +
      encodeURIComponent(state) +
      '&nonce=' +
      encodeURIComponent(state) +
      '&redirect_uri=' +
      encodeURIComponent(quickBooksConfig.redirectUri) +
      '&scope=' +
      encodeURIComponent(quickBooksConfig.scope);

    window.location.href = url;
  }

  generateState(returnRoute: string) {
    const stateParams = new OidcStateParams();
    stateParams.returnRoute = returnRoute;

    const state: string = btoa(JSON.stringify(stateParams));

    localStorage.setItem('aa-oidc-state', state);

    return state;
  }

  connect(command: ConnectQuickBooksCommand) {
    return this.http.post<ConnectIntegrationResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/quickBooks`,
      command,
    );
  }

  handleError(registerId, httpError, returnRoute) {
    if (
      httpError.status === 403 ||
      (Array.isArray(httpError.error) && httpError.error[0].message === 'invalid_grant')
    ) {
      if (
        registerId &&
        this.authorizationService.isRegisterAuthorized(
          registerId,
          RegisterPermissionType.CreateIntegrationConnection,
        )
      ) {
        this.modalService
          .showErrorModal(
            'We were unable to authenticate with QuickBooks, please reconnect and try again.',
            'Authentication Failure',
            'Reconnect',
          )
          .subscribe(_ => this.initiateOAuth(returnRoute));
      } else {
        this.modalService.showErrorModal(
          'We were unable to authenticate with QuickBooks, please ask an administrator to reconnect this register',
          'Authentication Failure',
          'OK',
        );
      }
    } else {
      throw httpError;
    }
  }
}
